<p-table class="ms-5"
         [value]="historyData"
         [columns]="headers"
         [styleClass]="'btable'"
         dataKey="aTime"      
>

  <ng-template pTemplate="body" let-rowData let-columns="headers" let-expanded="expanded">
    <tr>
      <td class="tn-data-tbl-body" [style.width.%]="col.width" *ngFor="let col of headers" style="border-top: 0px;">

        <div *ngIf="col.field === 'tn'" class="history-expand-row">
          <a href="#" [pRowToggler]="rowData"><i [ngClass]="expanded ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i></a>
        </div>

        <span *ngIf="!(col.field === 'tn')" >
          {{rowData[col.field] | notApplicable}}
        </span>

      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-rowData let-columns="headers">
    <tr>
      <td [attr.colspan]="headers.length + 1">
        <div class="ui-grid expand-tbl-only" style="margin-left:7em">
          <div class="ui-g" style="font-size:12px; font-weight: bold;">
            <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Routing Data</div></div></div>
            <div class="ui-g-2"></div>
            <div class="ui-g-2"></div>
            <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">More Porting Data</div></div></div>
            <div class="ui-g-2"></div>
            <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">IP Fields</div></div></div>
          </div>
          <div class="ui-g">
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Class DPC: {{rowData.clssDpc | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Class SSN: {{rowData.clssSsn | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LATA Name: {{rowData.lataName | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">End User Location Value: {{rowData.eulv | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Billing ID: {{rowData.billingId | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.voiceUri) " tooltipPosition="top" hideDelay="9000">Voice URI: {{getUri(rowData.voiceUri)}}</div></div></div>
          </div>
          <div class="ui-g">
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LIDB DPC: {{rowData.lidbDpc | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LIDB SSN: {{rowData.lidbSsn | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">LRN Switch: {{rowData.switch | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">End User Location Type: {{rowData.eult | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt Billing ID: {{rowData.altBid | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.mmsUri) " tooltipPosition="top" hideDelay="9000">MMS URI: {{getUri(rowData.mmsUri)}}</div></div></div>
          </div>
          <div class="ui-g">
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">ISVM DPC: {{rowData.isvmDpc | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">ISVM SSN: {{rowData.isvmSsn | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10"></div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt End User Location Value: {{rowData.altEulv | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">SVID: {{rowData.svId | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10" tooltipStyleClass="tn" [pTooltip]="getToolTip(rowData.smsUri) " tooltipPosition="top" hideDelay="9000">SMS URI: {{getUri(rowData.smsUri)}}</div></div></div>
          </div>
          <div class="ui-g">
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">CNAM DPC: {{rowData.cnamDpc | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">CNAM SSN: {{rowData.cnamSsn | notApplicable}}</div></div></div>
              <div class="ui-g-2"></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">Alt End User Location Type: {{rowData.altEult | notApplicable}}</div></div></div>
              <div class="ui-g-2"></div>
              <div class="ui-g-2"></div>
          </div>
          <div class="ui-g">
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">WSMSC DPC: {{rowData.wsmsDpc | notApplicable}}</div></div></div>
              <div class="ui-g-2"><div class="ui-g"><div class="ui-g-10">WSMSC SSN: {{rowData.wsmsSsn | notApplicable}}</div></div></div>
              <div class="ui-g-2"></div>
              <div class="ui-g-2"></div>
              <div class="ui-g-2"></div>
              <div class="ui-g-2"></div>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>
